/**
 * Which view-stack entry a component renders in, so dialogs can register their dismiss action
 * for the system back button (Android back, Escape): UiBridge.back() calls the top entry's.
 */
import { createContext } from 'preact';
import { useContext, useEffect, useRef } from 'preact/hooks';
import type { UiBridge } from './bridge.js';

export const Layer = createContext<{ id: number; ui: UiBridge } | null>(null);

/** Register `fn` as this layer's back action (Modal onClose, Screen onBack). */
export function useBack(fn: (() => void) | undefined): void {
  const layer = useContext(Layer);
  const ref = useRef(fn);
  ref.current = fn;
  useEffect(() => {
    if (!layer || !fn) return;
    return layer.ui.setBack(layer.id, () => ref.current?.());
  }, [layer?.id, !!fn]);
}
